<script>
import ProductCard from '@phoenix/mixins/components/product/ProductCard';
import WishlistButton from '../wishlist/WishlistButton';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import { PhxsgIcon } from '@sg/src/View/Components/Atoms/Icon';

export default {
  components: {
    WishlistButton,
    PhxsgButton,
    PhxsgIcon,
  },

  mixins: [ProductCard],

  props: {
    reference: {
      type: String,
      required: true,
    },
    modelReference: {
      type: String,
      required: true,
    },
    sapReference: {
      type: String,
      required: true,
    },
    defaultInWishlistIcon: {
      type: String,
      default: 'bookmark-active',
    },
    horizontalOnly: {
      type: Boolean,
      default: false,
    },
    isStrapOrBuckle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return [
        'product-card',
        {
          'product-card--horizontal': this.horizontal || this.horizontalOnly,
          'product-card--horizontal-only': this.horizontalOnly,
        },
      ];
    },

    linkTarget() {
      return this.openLinkInNewWindow ? '_blank' : '_self';
    },
  },
};
</script>

<template>
  <div :class="classes" :data-cy-reference="reference">
    <div class="product-card__wrapper">
      <div class="product-card__media">
        <div class="picture picture--full">
          <picture-lazy v-bind="image" />
        </div>
      </div>

      <div class="product-card__content">
        <div class="product-card__title body--weight-medium">
          <a v-if="!isStrapOrBuckle" :href="url" :target="linkTarget" class="expand-target" type="button">
            <span class="product-card__title-text">{{ name }}</span>
          </a>
          <span v-else class="product-card__title-text">{{ name }}</span>
        </div>

        <div class="product-card__price max-sm:title-caption md:body--weight-medium">
          <slot name="price" />
        </div>

        <div class="product-card__ref title-caption">{{ reference }}</div>

        <div
          v-for="error in errors"
          :key="`error_${id}_${error}`"
          class="alert box box--solid box--spacing-2 alert-badge box--inverted"
          data-cy="no-stock-alert-item"
        >
          <div>
            <PhxsgIcon id="info" />
          </div>

          <p>{{ $t(`Checkout.product.${error}.tag`) }}</p>
        </div>
      </div>
    </div>

    <div class="product-card__actions">
      <wishlist-button
        v-if="shouldDisplayAddToWishlist"
        :reference="modelReference"
        :name="name"
        :default-in-wishlist-icon="defaultInWishlistIcon"
      />

      <PhxsgButton
        v-if="shouldDisplayRemoveFromCart"
        icon-only
        icon-id="close"
        :data-cy="dataCyRemoveButton"
        @click.stop="onRemove({ id, tracking })"
      >
        {{ $t('Checkout.removeProduct', { product: name }) }}
      </PhxsgButton>
    </div>
  </div>
</template>
